<!--
 * @author: liqian
 * @date: Do not Edit
 * @description:
-->
<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view/>
      <loading></loading>
      <download-task-panel></download-task-panel>
    </div>
  </a-config-provider>
</template>

<script>
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
  import loading from "./components/common/comLoading.vue";
  import downloadTaskPanel from "./components/upload/downloadTaskPanel.vue";
  import { startAppVersionCheck, stopAppVersionCheck } from '@/utils/appVersionCheck';

  export default {
    name: 'App',
    components: {
      loading,
      downloadTaskPanel
    },
    data() {
      return {
        locale: zhCN,
      }
    },
    created() {
      //document.title = '景杰生物客户服务系统';
      console.log("深耕生物行业信息化建设十余年。" + '\n' +
        "有任何技术疑问或商务合作请联系柏伦，竭诚为您服务！ " + '\n' +
        "邮箱：iBelen@126.com" + '\n' +
        "电话：13661063814")
    },
    mounted() {
      startAppVersionCheck()
    },
    beforeDestroy() {
      stopAppVersionCheck()
    }
  }
</script>
<style>
  #app {
    height: 100%
  }

  /*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
  *::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: rgba(255, 255, 255, 0);
  }

  /*定义滚动条的轨道，内阴影及圆角*/
  *::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: rgba(230, 230, 230, 0.05);
  }

  *:hover::-webkit-scrollbar-track {
    background-color: rgba(230, 230, 230, 0.5);
  }

  /*定义滑块，内阴影及圆角*/

  *::-webkit-scrollbar-thumb {
    height: 20px;
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    background-color: rgba(216, 216, 216, 0.4);
    transition: background-color 1s;
  }

  *:hover::-webkit-scrollbar-thumb {
    background-color: rgba(216, 216, 216, 1);
  }

  *::-webkit-scrollbar-thumb:hover {
    background-color: rgba(190, 190, 190, 1);
  }

  *::-webkit-scrollbar-thumb:active {
    background-color: rgba(160, 160, 160, 1);
  }

  .ant-col-offset-5 {
    margin-left: 0px;
  }

  .ant-form-inline .ant-form-item {
    margin-right: 1px;
  }

  a:link {
    text-decoration: none;
  }

  a:visited {
    text-decoration: none;
  }

  a:hover {
    text-decoration: none;
  }

  a:active {
    text-decoration: none;
  }

  /*全局图片渐隐渐现*/
  .fade-in {
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
  }

  .fade-in.loaded {
    opacity: 1;
  }

  /*为状态的A标签显示下划线，全局设置*/
  .status_a {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue